import { render, staticRenderFns } from "./Screenfull.vue?vue&type=template&id=fddc8842&scoped=true"
import script from "./Screenfull.vue?vue&type=script&lang=js"
export * from "./Screenfull.vue?vue&type=script&lang=js"
import style0 from "./Screenfull.vue?vue&type=style&index=0&id=fddc8842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0_supports-color@6.1.0___css-loader@_035c03662a22344aa556e5f10fe24304/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddc8842",
  null
  
)

export default component.exports